<template>
  <div class="content">

    <div class="fixed">
      <b-navbar type="light" variant="light">
        <b-navbar-nav>
          <b-button pill variant="secondary" :to="urlBack()" v-if="hasBack()"><b-icon icon="caret-left" aria-hidden="true"></b-icon>Retour</b-button>
          <b-nav-text>{{data.account.name}} - {{data.company.name}}</b-nav-text>
          <!-- Navbar dropdowns -->
          <b-nav-item-dropdown text="Envoyer un e-mail" left v-if="data.operation" >
            <b-dropdown-item :href="`mailto:${data.account.name}<${data.account.email}>?subject=Operation ${data.operation.code} - ${data.operation.operationname}`" target="_blank">Compte : {{data.account.name}} - {{data.account.email}}</b-dropdown-item>
            <b-dropdown-item :href="`mailto:${data.company['operationOfficer.name']}<${data.company['operationOfficer.email']}>?subject=Operation ${data.operation.code} - ${data.operation.operationname}`" target="_blank" v-if="data.company['operationOfficer.email']">Resp. opérations : {{data.company['operationOfficer.name']}} - {{data.company['operationOfficer.email']}}</b-dropdown-item>
            <b-dropdown-item :href="`mailto:${data.company['companyOwner.name']}<${data.company['companyOwner.email']}>?subject=Operation ${data.operation.code} - ${data.operation.operationname}`" target="_blank" v-if="data.company['companyOwner.email']">Resp. entreprise : {{data.company['companyOwner.name']}} - {{data.company['companyOwner.email']}}</b-dropdown-item>
            <b-dropdown-item v-if="isAdmin()" :to="urlSendEmail()" >Email EU quand EE valide</b-dropdown-item>
            <b-dropdown-item v-if="isAdmin()" :to="urlSendEmailEE()" >Email EE</b-dropdown-item>
            <b-dropdown-item v-if="isAdmin()" :to="urlSendEmailEE()" >Email contact EE</b-dropdown-item>

          </b-nav-item-dropdown>

          <b-nav-item-dropdown text="Modifier" left>
            <b-dropdown-item v-if="data.account && isAdminManagerOrPartner()" :to="urlWithRedirect('/ppe_ee/home/'+data.account.id)">Accéder au compte : {{data.account.email}} - {{data.company.name}}</b-dropdown-item>
            <b-dropdown-item v-if="data.account && isAdminManagerOrPartner()" :to="urlWithRedirect('/ppe_ee/operation_ee/'+data.account.id+'/'+data.id)">Changer l'état de {{data.company.name}}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-navbar>
    </div>


    <div class="container-fluid">
      
      <div class="row" v-if="data.operation">
        <div class="col-lg-12 col-12">
          <stats-card :style="getCardStyle(data._status)">
            <div slot="content">
              <img v-if="data.operation.image && data.operation.image.length" style="max-height:200px;max-width:200px" class="float-right" :src="data.operation.image[0].url" />
              <h4 class="card-title"><status-icon :status="data._status" css-class="icon-small"/> {{data.operation.code}} - {{data.operation.operationname}} 
                <!-- <a v-if="isAdmin()" :href="'/ppe_eu/operation_home/'+data.operation.id">Retour opération (admin)</a> -->
                <router-link v-if="isAdmin()" :to="urlWithRedirect('/ppe_eu/operation_home/'+data.operation.id)">Retour opération (admin)</router-link>
              </h4>
              <h5 v-if="data.companyOp">{{data.companyOp.name}} - {{data.companyOp.city}} - {{data.companyOp.activity}} </h5>
              <div class="row">
                  <div class="col-lg-2 col-4"><span class="font-weight-bold">Opération</span></div>
                  <div class="col-lg-5 col-8">{{data.operation.code}}</div>
                  <div class="col-lg-2 col-4"><span class="font-weight-bold">Type</span></div> <!-- https://bootstrap-vue.org/docs/reference/utility-classes -->
                  <div class="col-lg-3 col-8">{{getOperationLabel(data.operation.type)}}</div>
              </div>
              <div class="row">
                  <div class="col-lg-2 col-4"><span class="font-weight-bold">Description</span></div>
                  <div class="col-lg-10 col-8"><span style="white-space: pre-line">{{data.operation.description}}</span></div>
              </div>
              <div class="row">
                <div class="col-lg-2 col-4"><span class="font-weight-bold">Adresse</span></div> 
                <div class="col-lg-10 col-8"><div>{{data.operation.sitename}}</div>
                <div>{{data.operation.address}} {{data.operation.zip}} {{data.operation.city}}</div></div>
              </div>
                  <div class="row">
                    <div class="col-lg-2 col-4"><span class="font-weight-bold">Début prévu</span></div>
                    <div class="col-lg-3 col-8">{{toDate(data.operation.startDate)}}</div>
                    <div class="col-lg-2 col-4"><span class="font-weight-bold">Durée</span></div> 
                    <div class="col-lg-3 col-8">{{data.operation.duration}}</div>
                  </div>
            </div>
            <div slot="footer">
                  <div>
                    <i v-if="this.data.d3" class="fa fa-calendar-o"></i> {{toDate(data._modified)}}
                    <span> | </span>
                    <router-link class="card-link" v-if="isAdminManagerOrPartner()" :to="urlWithRedirect('/ppe_ee/operation_ee/'+data.account.id+'/'+data.id)">Modifier état (admin)</router-link>
                  </div>
            </div>
          </stats-card>

        </div>

        <div class="col-lg-12 col-12 warning" v-if="this.data.hadD1D3Copied && (this.data.d1._status=='draft' || this.data.d3._status=='draft' || this.data.d4._status=='draft')">
          <i class="fa fa-warning"></i> Les documents D1 et D3 suivants ont été recopiés depuis votre précédente opération. Merci de les vérifier.
          <br />
          Vous devez également compléter le D4.
        </div>

        <!-- D0. Vos sous traitants -->
        <div class="col-lg-10 col-10">
          <stats-card :style="getCardStyle(data.d0._status)">
            <div slot="content">
              <h4 class="card-title"><status-icon v-if="this.data.d0" :status="this.data.d0._status" />
              <status-icon v-if="!this.data.d0" status="draft" /> D0. Vos sous traitants</h4>
              <p class="card-category">Liste de vos sous traitants intervenant sur cette opération</p>
              <p class="card-category">Vous avez déclaré {{ data.d0.contractors.length }} sous-traitant{{ data.d0.contractors.length>1?'s':'' }}</p>
              <b-table responsive striped hover :items="data.d0.contractors" :fields="contrator_fields" v-if="data.d0.contractors.length>0">

                <template #cell(action)="row">
                  <button class="btn btn-secondary btn-sm float-right" v-on:click="sendInviteWithConfirm(row.item.email, row.item.name)" >Envoyer un email d'invitation</button>
                </template>

                <template #cell(lastSent)="row">
                  {{toDate(row.item.lastSent)}}
                </template>

              </b-table>
            </div>
            <div slot="footer">
              <i v-if="this.data.d1" class="fa fa-calendar-o"></i> {{this.data.d0?toDate(this.data.d0._modified):''}}
              <span> | </span>
              <router-link :to="urlWithRedirect('/ppe_ee/d0/'+this.data.d0.id+'?operationid='+data.operation.id+'&companyid='+data.company.id)">Modifier</router-link>

            </div>
          
          </stats-card>

        </div>

        <!-- D1. Protocole de sécurité -->
        <div class="col-lg-5 col-12"> 
          <stats-card :style="getCardStyle(this.data.d1._status)">
            <div slot="content">
              <h4 class="card-title"><status-icon v-if="this.data.d1" :status="this.data.d1._status" />
              <status-icon v-if="!this.data.d1" status="draft" /> D1. Protocole de sécurité</h4>
              <p class="card-category">Opérations de chargement et de déchargement</p>
              <p class="card-category">(art R4515-1 à R4515-11 du C du T précisé par arrêté du 26 04 96)</p>
            </div>
            <div slot="footer">
              <i v-if="this.data.d1" class="fa fa-calendar-o"></i> {{this.data.d1?toDate(this.data.d1._modified):''}}
              <span> | </span>
              <router-link :to="urlWithRedirect('/ppe_ee/d1/'+this.data.d1.id+'?operationid='+data.operation.id+'&companyid='+data.company.id)">Modifier</router-link>
              <span> | </span>
              <a href="#"  @click="downloadD1PDF" class="card-link" v-if="['doing','valid'].includes(data.d1._status)">
                      <!-- https://bootstrap-vue.org/docs/icons#icons-1 -->
                      <b-icon icon="file-earmark-arrow-down" title="Télécharger au format PDF"></b-icon>Télécharger
                      <b-icon icon="arrow-clockwise" animation="spin" font-scale="2" v-if="pdfD1Loading"></b-icon>
                      </a> 

            </div>
          </stats-card>
        </div>

        <!-- D3. LAP Livret d'Accueil -->
        <div class="col-lg-5 col-12"> 
          <stats-card :style="getCardStyle(this.data.d3._status)">
            <div slot="content">
              <h4 class="card-title"><status-icon v-if="this.data.d3" :status="this.data.d3._status" />
              <status-icon v-if="!this.data.d3" status="draft" /> D3. LAP Livret d'Accueil Prévention</h4>
              <p class="card-category">Analyse des principaux dangers</p>
              <p class="card-category">Cochez tous vos risques dans la colonne E.E.</p>
            </div>
            <div slot="footer">
              <i v-if="this.data.d3" class="fa fa-calendar-o"></i> {{this.data.d3?toDate(this.data.d3._modified):''}}
              <span> | </span>
              <router-link :to="urlWithRedirect('/ppe_ee/d3/'+this.data.d3.id+'?operationid='+data.operation.id+'&companyid='+data.company.id)">Modifier</router-link>
            </div>
          </stats-card>
        </div>

        <!-- D4. Bordereau d’Engagement SST de l’OPERATION -->
        <div class="col-lg-5 col-12"> 
          <stats-card :style="getCardStyle(this.data.d4._status)">
            <div slot="content">
              <h4 class="card-title"><status-icon v-if="this.data.d4" :status="this.data.d4._status" />
              <status-icon v-if="!this.data.d4" status="draft" /> D4. Bordereau d’Engagement SST de l’OPERATION</h4>
              <p class="card-category">Description / inspection / signature</p>

              
            </div>
            <div slot="footer">
              <i v-if="this.data.d4" class="fa fa-calendar-o"></i> {{this.data.d4?toDate(this.data.d4._modified):''}}
              <span> | </span>
              <router-link :to="urlWithRedirect('/ppe_ee/d4/'+this.data.d4.id+'?operationid='+data.operation.id+'&companyid='+data.company.id)">Modifier</router-link>
              <span> | </span>
              <a href="#"  @click="downloadD4PDF" class="card-link" v-if="['doing','valid'].includes(data.d4._status)">
                      <!-- https://bootstrap-vue.org/docs/icons#icons-1 -->
                      <b-icon icon="file-earmark-arrow-down" title="Télécharger au format PDF"></b-icon>Télécharger
                      <b-icon icon="arrow-clockwise" animation="spin" font-scale="2" v-if="pdfD4Loading"></b-icon>
                      </a> 
             </div>
          </stats-card>
        </div>

        <div class="col-lg-5 col-12"> 
          <div :style="getCardStyle('valid') + '; padding: 10pt;'" class="card">
            <h4 class="card-title">Plan de Prévention Evolutif de l'EU sur l'opération</h4>
            <div slot="content">
              <a href="#" v-if="docsCompleted()" @click="downloadPDF" class="card-link">
                  <!-- https://bootstrap-vue.org/docs/icons#icons-1 -->
                  <b-icon icon="file-earmark-arrow-down" title="Visualiser au format PDF"></b-icon>
                  Télécharger le PPE
                  <b-icon icon="arrow-clockwise" animation="spin" font-scale="2" v-if="pdfLoading"></b-icon>
              </a> 
              <div v-if="!docsCompleted()" >
                Vous pourrez télécharger le PPE, après validation D3 & D4
              </div>
            </div>
          </div>
        </div>
      </div>


      
      
    </div>
  </div>
</template>
<script>
  
  import ChartCard from '../../components/Cards/ChartCard.vue'
  import StatsCard from '../../components/Cards/StatsCard.vue'
  import StatusIcon from '../../components/StatusIcon.vue'

  import Business from 'ppe-business'
  import common from '../common/pages.js'

  export default {
    components: {
      ChartCard,
      StatsCard,
      StatusIcon
    },


    mounted() {
      this.$http.get('/ee/operation_subscription_home?id='+this.$route.params.id) // this.$router.app._route.query.id)
        .then(response => {
          console.log("/ee/operation_subscription_home:DATA", response.data)
          this.data = response.data
					/*this.operation = response.data.operation
          this.company = response.data.company
          this.account = response.data.account
          this.d1 = response.data.d1
          this.d2 = response.data.d2
          this.d3 = response.data.d3
          this.d4 = response.data.d4
          this.d5 = response.data.d5
          this.d6 = response.data.d6*/
          } )
        .catch(err => {
          // Clone the error to read the status property (otherwise it can only be read once !!!!)
          let error = JSON.parse( JSON.stringify(err) )
          console.error("ERROR", JSON.stringify(error))
					swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
          //if(error.status === 401)
          //   this.$router.replace("/login?redirect="+error.config.url)
        })
    },

    data () {
      return {
        pdfLoading : false,
        pdfD4Loading:false,
        pdfD1Loading:false,
        contrator_fields: [
          {key:'name',   label: 'Entreprise'},
          {key:'email',  label: 'Email'},
          {key:'tasks',  label: 'Tâches'},
          {key:'action', label: 'Action'}, 
          {key:'lastSent', label: 'Dernier envoi'}, 
        ],
        data : {},
        
       }
    },

    methods:{
      ...common.methods,

      toDate(apiDate) { return Business.toDate(apiDate) },
      getOperationLabel(operationType) { return Business.getOperationLabel(operationType) },
      urlSendEmail() {
        return this.urlWithRedirect(`/admin/sendemail?template_id=mail_valid_ee&eeid=${this.data.company.id}&euid=${this.data.operation.company.id}&operationid=${this.data.operation.id}&accountid=${this.data.operation.company.owner}`)
      },
      urlSendEmailEEContact() {
        return this.urlWithRedirect(`/admin/sendemail?template_id=mail_contact_ee&eeid=${this.data.company.id}&euid=${this.data.operation.company.id}&operationid=${this.data.operation.id}&accountid=${this.data.company.owner}`)
      },
      urlSendEmailEE() {
        return this.urlWithRedirect(`/admin/sendemail?template_id=mail_ee&eeid=${this.data.company.id}&euid=${this.data.operation.company.id}&operationid=${this.data.operation.id}&accountid=${this.data.company.owner}`)
      },
      downloadD4PDF() { 
        this.pdfD4Loading = true
        this.$http.get('/form/d4_pdf?id='+this.data.d4.id, {responseType: 'arraybuffer', timeout:30000}) 
        .then(response=> {
          //console.log(response)
          //this.$http.timeout = lastTimeout
          let blob = new Blob([response.data], { type: 'application/pdf' })
          // Download file and give it a name
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'PPE-BORDEREAU-ENGAGEMENT-'+this.data.operation.code+'.pdf'
          this.pdfD4Loading = false
          link.click()

        })
        .catch( err => {
          //this.$http.timeout = lastTimeout
          this.pdfD4Loading = false
          //console.error("ERROR 1")
          let responseError = err.response
          let blobErr = new Blob([responseError.data], { type: 'application/json' })
          //console.log(responseError)
          let fileReader = new FileReader()
          
          fileReader.onload = (e) => {
            console.error("ERROR 1")
            console.error(JSON.parse(e.target.result))
  					swal("Erreur", JSON.stringify(JSON.parse(e.target.result).error), "error");
          }
          
          fileReader.readAsText(blobErr)
          
          console.log("ERROR BLOB", blobErr)
          //let error = JSON.parse(JSON.stringify(err))
          //console.error("ERROR 2", JSON.stringify(error))
        })
      },

      downloadD1PDF() { 
        this.pdfD1Loading = true
        this.$http.get('/form/d1_pdf?id='+this.data.d1.id, {responseType: 'arraybuffer', timeout:30000}) 
        .then(response=> {
          let blob = new Blob([response.data], { type: 'application/pdf' })
          // Download file and give it a name
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'PPE-PROTOCOLE-SECURITE-'+this.data.operation.code+'.pdf'
          this.pdfD1Loading = false
          link.click()

        })
        .catch( err => {
          this.pdfD1Loading = false
          let responseError = err.response
          let blobErr = new Blob([responseError.data], { type: 'application/json' })
          let fileReader = new FileReader()
          
          fileReader.onload = (e) => {
            console.error("ERROR 1")
            console.error(JSON.parse(e.target.result))
  					swal("Erreur", JSON.stringify(JSON.parse(e.target.result).error), "error");
          }
          
          fileReader.readAsText(blobErr)
          
          console.log("ERROR BLOB", blobErr)
        })
      },

      downloadPDF() {
        this.pdfLoading = true;
        //console.log("this.$http", this.$http.config())
        //let lastTimeout = this.$http.timeout;
        //this.$http.timeout = 30000
        this.$http.get('/form/operation_pdf?operationId='+this.data.operation.id, {responseType: 'arraybuffer', timeout:30000}) 
        .then(response=> {
          //console.log(response)
          //this.$http.timeout = lastTimeout
          let blob = new Blob([response.data], { type: 'application/pdf' })

          /*let url = window.URL.createObjectURL(blob)
          this.pdfLoading = false
          let win = window.open(url)*/
 
          /*const newWindow = window.open()
          newWindow.document.title = 'My Tab Name'
          newWindow.document.write(`<iframe src="${URL.createObjectURL(blob)}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`)
          */

          /*let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'PPE-'+this.operation.code+'.pdf'
          link.click()*/

          // Download file and give it a name
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'PPE-'+this.data.operation.code+'.pdf'
          this.pdfLoading = false
          link.click()
        })
        .catch( err => {
          //this.$http.timeout = lastTimeout
          this.pdfLoading = false
          //console.error("ERROR 1")
          let responseError = err.response
          let blobErr = new Blob([responseError.data], { type: 'application/json' })
          //console.log(responseError)
          let fileReader = new FileReader()
          
          fileReader.onload = (e) => {
            console.error("ERROR 1")
            console.error(JSON.parse(e.target.result))
  					swal("Erreur", JSON.stringify(JSON.parse(e.target.result).error), "error");
          }
          
          fileReader.readAsText(blobErr)
          
          console.log("ERROR BLOB", blobErr)
          //let error = JSON.parse(JSON.stringify(err))
          //console.error("ERROR 2", JSON.stringify(error))
        })
      },
      isAdmin() {
        return this.$usermanager.isAdmin() //|| this.$usermanager.isImpersonating()
      },
      docsCompleted() {
        let states = ['valid']
        return states.indexOf(this.data.d3._status) >=0 && states.indexOf(this.data.d4._status)>=0
      },
      async sendInviteWithConfirm(email, companyName) {
        var answer = await swal({
              title: 'Confirmez ?',
              text: `Vous allez envoyer une invitation à ${email} à rejoindre l'opération ${this.data.operation.code}\n`,
              icon: 'info',
              
              buttons: {
                    cancel:  "Non, annuler",
                    confirm: {text:"Oui, envoyer", className:"btn btn-info"},
              },
            })
            if(answer) {
              //try {
                let response = await this.$http.post("/ee/operation_invite", 
                  { code:this.data.operation.code, 
                    operationname:this.data.operation.operationname,
                    sitename:this.data.operation.sitename,
                    operationid:this.data.operation.id, 
                    to:email, 
                    company:companyName, 
                    accountName:this.data.account.name, 
                    accountCompany:this.data.company.name
                  });

                swal({
                  title: "Email envoyé !",
                  text: `A: ${email} de la société ${companyName}`,
                  icon: "success"
                });

                this.invites = response.data.invites

              /*} catch(err) {
                swal("Erreur", JSON.stringify( err.response ? err.response.data : err.message), "error");
              } */
            }
      },
    },

  }
</script>
<style>

</style>
